module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/dx_bg-1d21bd1f15077a7c7be8104e4e230d36.jpg";